import { GENERATE_REPORT, GET_ALL_REPORTS } from '../../actions/reports';

const reportsReducers = (state = {}, action = {}) => {
  const { type = '', reportsData = {}, generateReportDetails = {} } = action;

  switch (type) {
    case GET_ALL_REPORTS.INITIATE:
      return {
        ...state,
      };
    case GET_ALL_REPORTS.SUCCESS:
      return {
        ...state,
        reportsData,
      };
    case GET_ALL_REPORTS.FAILED:
      return {
        ...state,
      };
    case GENERATE_REPORT.INITIATE:
      return {
        ...state,
      };
    case GENERATE_REPORT.SUCCESS:
      return {
        ...state,
        generateReportDetails,
      };
    case GENERATE_REPORT.FAILED:
      return {
        ...state,
      };
    case GENERATE_REPORT.CLEAR:
      return {
        ...state,
        generateReportDetails: {},
      };
    default:
      return state;
  }
};

export default reportsReducers;
